import { render } from "./IOSTestflightFaq.vue?vue&type=template&id=395eb617&scoped=true"
import script from "./IOSTestflightFaq.vue?vue&type=script&lang=js"
export * from "./IOSTestflightFaq.vue?vue&type=script&lang=js"

import "./IOSTestflightFaq.vue?vue&type=style&index=0&id=395eb617&scoped=true&lang=css"

import exportComponent from "/workspace/goj/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-395eb617"]])

export default __exports__